import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // 只在生产环境中执行
    if (process.env.NODE_ENV === 'production') {
      // 通知 Clarity 页面已更改
      if (window.clarity) {
        window.clarity("set", "page_path", location.pathname);
        window.clarity("set", "page_location", window.location.href);
      }
    }
  }, [location]);
}; 